import { Component } from '@angular/core';

@Component({
  selector: 'app-sblock-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class SblockProductsComponent {
  title = 'Nuestros cursos destacados';
  subtitleText = 'Explora una seleccion de nuestros cursos mas populares y comienza hoy mismo.';
  titlesColor = '#2c2c54';
  secondaryColor = '#555';

  language = 'es';

  productList: Array<any> = [
    {
      id: 1,
      name: 'Introduccion a la vida espiritual',
      image: 'https://picsum.photos/seed/curso-vida-espiritual/400/300',
      price: 'Gratis',
      free: true
    },
    {
      id: 2,
      name: 'Oracion y meditacion diaria',
      image: 'https://picsum.photos/seed/curso-oracion/400/300',
      price: '$24.99',
      free: false
    },
    {
      id: 3,
      name: 'Historia de las Adoratrices',
      image: 'https://picsum.photos/seed/curso-historia/400/300',
      price: '$19.99',
      free: false
    }
  ];

  btn1Active = true;
  btn1Text = 'Ver todos los cursos';
  btn1Link = '#';

  btn2Active = false;
  btn2Text = 'Mas informacion';
  btn2Link = '#';
}
